import _regeneratorRuntime from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/asyncToGenerator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
export default {
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true,
      keepLive: ['goods-list-id', 'cart']
    };
  },
  name: 'App',
  preFetch: function preFetch(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            store = _ref.store, currentRoute = _ref.currentRoute, previousRoute = _ref.previousRoute, redirect = _ref.redirect, ssrContext = _ref.ssrContext, urlPath = _ref.urlPath, publicPath = _ref.publicPath;
            if (!process.env.SERVER) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return store.dispatch('nuxtServerInit');
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    token: function token() {
      return this.$store.state.token;
    },
    theme: function theme() {
      return this.$store.state.theme;
    }
  },
  watch: {
    token: {
      handler: function handler(val) {
        this.$store.commit('loginState', !!val);
      },
      immediate: true
    },
    globalConfig: {
      handler: function handler(val) {
        var _this = this;
        this.$nextTick(function () {
          if (_this.globalConfig.themeColor && !process.env.SERVER) {
            document.querySelector('html').style.setProperty('--twc-primary', _this.globalConfig.themeColor);
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created: function created() {
    if (this.$q.platform.is.mobile) {
      try {
        var redirect = function redirect(path) {
          window.location.replace(window.location.origin + path);
        };
        var _window$location = window.location,
          pathname = _window$location.pathname,
          search = _window$location.search;
        var normalizedPath = pathname.replace(/\/+$|^\s+|\s+$/g, '') || '/';
        var goodsDetail = normalizedPath.match(/^\/goods\/(\d+)$/);
        if (goodsDetail) {
          var id = goodsDetail[1];
          redirect("/h5/pages/goods/detail?id=".concat(encodeURIComponent(id), "&source=pc"));
          return;
        }
        var goodsListMatch = normalizedPath.match(/^\/goods\/list(?:\/(.+))?$/);
        if (goodsListMatch) {
          var _id = goodsListMatch[1] || '';
          if (!_id || _id === 'all') {
            redirect("/h5/pages/goods/index?id=");
            return;
          }
          redirect("/h5/pages/goods/index?id=".concat(encodeURIComponent(_id)));
          return;
        }
        if (/^\/goods\/search\/all\/?$/.test(pathname)) {
          var params = new URLSearchParams(search);
          var keyword = params.get('keyword') || '';
          var searchType = params.get('searchType');
          var allowEmpty = params.get('allowEmpty');
          if (searchType === 'thzq' && allowEmpty === '1') {
            redirect("/h5/pages/search/index?searchType=thzq&keyword=");
            return;
          }
          redirect("/h5/pages/search/index?keyword=".concat(encodeURIComponent(keyword)));
          return;
        }
        if (/^\/allcat\/?$/.test(pathname)) {
          redirect("/h5/pages/classify/index");
          return;
        }
        if (/^\/cart\/?$/.test(pathname)) {
          redirect("/h5/pages/shoppingcar/index");
          return;
        }
        if (/^\/user\/order\/?$/.test(pathname)) {
          redirect("/h5/pages/order/order-list");
          return;
        }
        if (/^\/user\/renzhengFranchisee\/?$/.test(pathname)) {
          redirect("/h5/pages/user/clientAuthFranchisee");
          return;
        }
        redirect('/h5');
      } catch (e) {
        window.location.replace(window.location.origin + '/h5');
      }
    }
  },
  mounted: function mounted() {
    document.documentElement.classList.add(this.theme == 'light' ? 'theme-light' : 'theme-dark');
    document.documentElement.classList.add(this.theme == 'light' ? 'light' : 'dark');
    if (this.theme == 'dark') {
      this.$q.dark.toggle();
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
  },
  meta: function meta() {
    return {
      title: this.seoData.seoTitle,
      meta: {
        keywords: {
          name: 'keywords',
          content: this.seoData.seoKeyWord
        },
        description: {
          name: 'description',
          content: this.seoData.seoContent
        }
      }
    };
  }
};